import { dateFormatter } from "project-config/utils/date-formatter";
import { useGlobalStore } from "@/store/GlobalStore";
import { Zone } from "project-config/constants/user-info";
import { useTranslation } from "react-i18next";
import { PaymentTypeCode } from "project-config/constants";

export function useGetInvoiceOrderTable() {
  const { t } = useTranslation("invoice");
  const { userInfo } = useGlobalStore();
  const columns = [
    {
      title: t("invoice_record_header_id"),
      dataIndex: "payRecordId",
    },
    {
      title: t("invoice_trade_time"),
      dataIndex: "confirmDate",
      render: (row: number) => dateFormatter(row),
    },
    {
      title: t("invoice_header_amount"),
      dataIndex: "amount",
      render: (row: number) =>
        `${userInfo?.zone === Zone.Domestic ? "￥" : "$"}${row}`,
    },
    {
      title: t("invoice_business_type"),
      dataIndex: "businessType",
      width: 100,
      render: (_: any, row: any) => {
        const isDesktop = [
          PaymentTypeCode.DesktopAlipay,
          PaymentTypeCode.DesktopWechat,
        ].includes(row.payMethod);
        return t(`invoice_business_type_${Number(isDesktop)}`);
      },
    },
    {
      title: t("invoice_pay_method"),
      dataIndex: "payMethod",
      render: (row: number) => t(`invoice_pay_method_${row}`),
    },
  ];
  return columns;
}
